import { render } from "./InventoryUpload.vue?vue&type=template&id=746c5cea&scoped=true"
import script from "./InventoryUpload.vue?vue&type=script&lang=js"
export * from "./InventoryUpload.vue?vue&type=script&lang=js"

import "./InventoryUpload.vue?vue&type=style&index=0&id=746c5cea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-746c5cea"]])

export default __exports__